module.exports = __webpack_public_path__ + "static/img/7c.de0282f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7c.jpg
// module id = CiD4
// module chunks = 0